import React from 'react';
import { Path, Svg } from 'react-native-svg';

export interface MoreVerticalIconProps {
    size?: number;
    color?: string;
}

export const MoreVerticalIcon: React.FC<MoreVerticalIconProps> = ({
    size = 24,
    color = '#333333',
}) => {
    return (
        <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <Path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.4}
                d="M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            />
        </Svg>
    );
};

export default MoreVerticalIcon;
